'use client';

import { motion } from 'framer-motion';
import { Euro, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface IntroStepProps {
	onContinue: () => void;
}

export default function IntroStep({ onContinue }: IntroStepProps) {
	return (
		<motion.div
			initial={{ opacity: 0, y: 10 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.3 }}
			className="max-w-2xl mx-auto px-4 py-8 md:py-12"
		>
			<div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-10 space-y-6">
				<div>
					<h3 className="text-xl md:text-2xl font-bold font-heading text-blue-dark mb-4">
						Persoonlijk advies aan huis door de experts van Breuer Klimaattechniek B.V.
					</h3>
					<div className="space-y-4 text-base md:text-lg text-gray-dark leading-relaxed">
						<p>Bent u op zoek naar een passend advies voor de installatie van een airconditioning?</p>
						<p>Dan komen wij graag bij u langs voor een persoonlijk adviesbezoek.</p>
						<p>
							Tijdens dit bezoek beoordelen wij de situatie op locatie, bespreken wij uw wensen en nemen wij
							samen met u de verschillende mogelijkheden door voor uw woning of bedrijfspand.
						</p>
						<p>
							Hierbij kijken wij naar de meest geschikte plaatsing, het gewenste comfort, de technische
							mogelijkheden en de beste oplossing voor uw situatie.
						</p>
						<p>
							Op basis van onze bevindingen ontvangt u een vrijblijvende offerte op maat, volledig
							afgestemd op uw wensen en omstandigheden.
						</p>
					</div>
				</div>

				<div className="flex items-start gap-3 text-sm md:text-base font-medium text-blue-dark bg-blue-light p-4 rounded-md border border-blue-dark/10">
					<Euro className="size-5 flex-shrink-0 mt-0.5" />
					<div className="space-y-2 font-normal">
						<p>
							De kosten voor een adviesbezoek bedragen <span className="font-bold">€ 75,00 inclusief btw</span>.
						</p>
						<p>
							Besluit u de installatie door Breuer Klimaattechniek B.V. te laten uitvoeren en gaat u akkoord
							met onze offerte? Dan brengen wij de kosten van het adviesbezoek volledig in mindering op het
							offertebedrag. Het adviesbezoek is in dat geval dus geheel kosteloos.
						</p>
						<p>
							Maakt u geen gebruik van onze offerte, dan brengen wij de kosten van het adviesbezoek
							(€ 75,00 inclusief btw) in rekening. Zo bent u verzekerd van een deskundig, eerlijk en
							persoonlijk advies, waarbij wij alle tijd nemen om samen met u tot de beste oplossing te komen.
						</p>
					</div>
				</div>

				<p className="text-base md:text-lg text-gray-dark">
					Wij kijken ernaar uit u binnenkort te mogen adviseren.
				</p>

				<div className="text-base md:text-lg text-gray-dark">
					<p>Met vriendelijke groet,</p>
					<p className="font-semibold text-blue-dark">René &amp; Frank Breuer</p>
					<p className="text-sm text-gray-500">Breuer Klimaattechniek B.V.</p>
				</div>

				<div className="pt-4 border-t border-gray-200 flex justify-end">
					<Button
						type="button"
						onClick={onContinue}
						className="bg-orange hover:bg-orange-hover text-white font-bold px-8 w-full md:w-auto"
					>
						Ga verder naar het formulier <ArrowRight className="ml-2 size-4" />
					</Button>
				</div>
			</div>
		</motion.div>
	);
}
